import type { CharacterGridSpec } from "@/character/grid";
import { idleAnimationFrameRange } from "@/character/spritesheet";
import { addSkillSpritesheetTexture } from "@/game/load-data-texture";
import { normalizeImageDataUrl } from "@/home/image-data-url";
import type Phaser from "phaser";

const TOWER_MONSTER_DISPLAY_H = 56;

export function towerMonsterTextureKey(instanceKey: string): string {
  return `tower-monster-sheet-${instanceKey}`;
}

export function towerMonsterIdleAnimKey(instanceKey: string): string {
  return `tower-monster-idle-${instanceKey}`;
}

export function towerSpawnHasSheet(
  spawn: { spritesheetDataUrl?: string; grid?: CharacterGridSpec },
): boolean {
  return Boolean(
    spawn.spritesheetDataUrl?.startsWith("data:") &&
      spawn.grid &&
      spawn.grid.frameWidth > 0 &&
      spawn.grid.frameHeight > 0,
  );
}

export async function registerTowerMonsterSheet(
  scene: Phaser.Scene,
  instanceKey: string,
  sheetUrl: string,
  grid: CharacterGridSpec,
): Promise<string> {
  const texKey = towerMonsterTextureKey(instanceKey);
  if (!scene.textures.exists(texKey)) {
    await addSkillSpritesheetTexture(
      scene.textures,
      texKey,
      normalizeImageDataUrl(sheetUrl),
      grid.frameWidth,
      grid.frameHeight,
    );
  }
  const idleKey = towerMonsterIdleAnimKey(instanceKey);
  if (!scene.anims.exists(idleKey)) {
    const { start, end } = idleAnimationFrameRange(grid);
    scene.anims.create({
      key: idleKey,
      frames: scene.anims.generateFrameNumbers(texKey, { start, end }),
      frameRate: 8,
      repeat: -1,
    });
  }
  return texKey;
}

export function fitTowerMonsterSprite(
  sprite: Phaser.GameObjects.Sprite,
  grid: CharacterGridSpec,
  cellsH: number,
): void {
  const targetH = Math.max(TOWER_MONSTER_DISPLAY_H, cellsH * 48 * 0.85);
  const scale = targetH / grid.frameHeight;
  sprite.setScale(scale);
  sprite.setOrigin(0.5, 1);
}
